import React from 'react'
import PrintWeekProgramFlyerContainer from './PrintWeekProgramFlyerContainer'
import PrintFlyerContainer from './PrintFlyerContainer'
import { FLYER, SHOWCASE, SHOWCASEREDUCED, WEEKPOSTER, WEEKPROGRAMFLYER } from '../../../constants/printType'
import EditPrintTypeContainer from './EditPrintTypeContainer'
import { generatePath } from 'react-router-dom'


const EditPrintContainer = ({match, goBackPath}) => {
    const { params, url } = match
    const { printType } = params
    const closePagePath = generatePath(goBackPath, params)

    if (FLYER === printType) {
        return <PrintFlyerContainer
            params={params}
            basicUrl={url}
            closePagePath={closePagePath}
        />
    } else if(SHOWCASE === printType || WEEKPOSTER === printType || SHOWCASEREDUCED === printType) {
        return <EditPrintTypeContainer
            params={params}
            basicUrl={url}
            closePagePath={closePagePath}
        />
    } else if(WEEKPROGRAMFLYER === printType) {
        return <PrintWeekProgramFlyerContainer
            params={params}
            basicUrl={url}
            closePagePath={closePagePath}
        />
    }  else {
        return <div>Component under development</div>
    }
}

export default EditPrintContainer